import React from 'react';
import styles from './dive-teaser-card.module.scss';
import { CosmosButton } from '../../cosmos/web-scoped/react';

const DiveTeaserCard = ({ setShowDive, launcher, expand }) => {
  return (
    <div className={styles.cardTeaser}>
      <span>{launcher}</span>
      <CosmosButton
        onClick={setShowDive}
        style={{ alignSelf: 'center' }}
        kind="secondary"
        shape="pill">
        {expand}
      </CosmosButton>
    </div>
  );
};

export { DiveTeaserCard };
